import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";

const ChannelActivityModal = ({ details, onCancel }) => {
  const beforeData = JSON?.parse(details?.before);
  const afterData = JSON?.parse(details?.after);

  return (
    <Grid
      container
      py={6}
      width={"700px"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
    >
      <Grid
        item
        width={"80%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            marginBottom: "12px",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "36px",
            color: "#000000",
            fontFamily: "Open-Sans",
          }}
        >
          CHANNEL RULE ACTIVITY
        </Typography>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <tbody
            style={{
              margin: "0px auto",
            }}
          >
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-header-data">
                <p>Before</p>
              </td>
              <td className="rule-approval-table-header-data">
                <p>After</p>
              </td>
            </tr>
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Modifier</h5> <p>{beforeData?.Email ?? "-"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Modifier</h5>
                  <p>{afterData?.Email ?? "-"}</p>
                </div>
              </td>
            </tr>
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Vendor</h5> <p>{beforeData?.Name ?? "-"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Vendor</h5>
                  <p>{afterData?.Name ?? "-"}</p>
                </div>
              </td>
            </tr>
            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>USSD:</h5>
                  <p>{beforeData?.Ussd ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>USSD:</h5>
                  <p>{afterData?.Ussd ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>MOBILE:</h5>
                  <p>{beforeData?.Mobile ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>MOBILE:</h5>
                  <p>{afterData?.Mobile ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>INTERNET:</h5>
                  <p>{beforeData?.Internet ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>INTERNET:</h5>
                  <p>{afterData?.Internet ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>ATM:</h5> <p>{beforeData?.Atm ? "True" : "False"}</p>
                </div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>ATM:</h5>
                  <p>{afterData?.Atm ? "True" : "False"}</p>
                </div>
              </td>
            </tr>

            <tr className="rule-approval-table-row">
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont"></div>
              </td>
              <td className="rule-approval-table-data">
                <div className="rule-approval-table-data-cont">
                  <h5>Date</h5>
                  <p className="rule-approval-date">
                    {details?.eventTime?.substr(0, 10) ?? "-"}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <Box
          py={2}
          display={"flex"}
          justifyContent={"space-around"}
          columnGap={"20px"}
        >
          <Button
            variant="contained"
            sx={{
              background: "#255CFF",
              textTransform: "capitalize",
              fontFamily: "Open-Sans",
              "&:hover": {
                backgroundColor: "#255CFF",
                color: "white",
                borderColor: "white",
              },
            }}
            onClick={() => {
              onCancel(false);
            }}
          >
            Close
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ChannelActivityModal;
